<template>
    <div style="height: 100%;">
        <el-container>
            <el-header class="homeHeader">
                <img class="logo" src="../assets/img/lololo.png" alt="" />
                <div class="web-title" style="color: white; white-space: nowrap; flex-shrink: 0;">数据资产全过程AI服务平台</div>



                <div style="flex-grow: 1;"></div>
                <div>
                    <el-button icon="el-icon-bell" type="text" style="margin-right: 8px;color: #00b5ad;"
                        size="normal"></el-button>
                    <el-dropdown class="userInfo" @command="commandHandler">
                        <span class="el-dropdown-link" style="color: white">
                            <span v-text="this.user.name"></span><i><img :src=this.user.avatar alt=""></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="userInfo">个人中心</el-dropdown-item>
                            <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="primary"
                        style="margin-left: 20px;background-color: #274b86;border-color: #303f9f; white-space: nowrap;"
                        @click="goToCompanyHome">
                        官网首页
                    </el-button>
                </div>
            </el-header>
            <el-container>
                <el-aside :style="{ width: widthVal }" class="sidebar-container">
                    <el-row>
                        <el-col :span="24">
                            <div class="sidebar">
                                <el-menu :collapse="isCollapse" :collapse-transition="false" router
                                    class="el-menu-vertical-demo1" background-color="#262f3e" text-color="#fff"
                                    active-text-color="#00b5ad">
                                    <el-submenu :index="index + ''" v-for="(item, index) in visibleRoutes" :key="index">
                                        <template slot="title">
                                            <i style="color: #E4E7ED;margin-right: 5px" :class="item.iconCls"></i>
                                            <span v-text="item.name"></span>
                                        </template>
                                        <el-menu-item :index="child.path" v-for="(child, index1) in item.children"
                                            :key="index1">
                                            {{ child.name }}
                                        </el-menu-item>
                                    </el-submenu>
                                </el-menu>
                            </div>
                        </el-col>
                    </el-row>
                </el-aside>
                <el-main style="background: #f7f7f7;">
                    <div class="nav-tabs">
                        <el-tabs ref="tabs" v-model="activeTab" type="card" closable @tab-remove="removeTab"
                            @tab-click="tabClick" @prev-click="scrollPrev" @next-click="scrollNext">
                            <el-tab-pane v-for="tab in tabs" :key="tab.fullPath" :label="tab.title" :name="tab.fullPath"
                                :closable="tab.closable">
                                <template #label>
                                    <span class="custom-tab-label">
                                        {{ tab.title }}
                                    </span>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <el-breadcrumb separator-class="el-icon-arrow-right" v-if="false">
                        <!-- 隐藏面包屑导航 -->
                    </el-breadcrumb>
                    <!-- 根据路由配置规则自动加载组件 -->
                    <router-view></router-view>
                    <!-- 导航标签页 -->

                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import { initMenu } from "../utils/menu";

export default {
    data() {
        return {
            isCollapse: false,
            user: JSON.parse(window.localStorage.getItem('user')),
            widthVal: '200px',
            tabs: [],
            activeTab: '',
            tabIndex: 0
        };
    },
    computed: {
        routes() {
            return this.$store.state.routes;
        },
        visibleRoutes() {
            return this.routes.filter(item => !item.hidden);
        }
    },
    watch: {
        '$route': {
            handler(to, from) {
                if (to.path !== from?.path) {
                    this.addTab(to);
                    this.keepMenuOpen(to.path);
                    this.setActiveTabByRoute(to);
                }
            },
            immediate: true,
            deep: true
        }
    },

    mounted() {
        initMenu(this.$router, this.$store);
        this.addTab(this.$route);
        this.keepMenuOpen(this.$route.path);
        this.setActiveTabByRoute(this.$route);


        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
        this.handleResize(); // 初始化调用
    },
    beforeDestroy() {
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {

        // 处理窗口大小变化
        handleResize() {
            this.screenWidth = document.documentElement.clientWidth;

            // 在1024px及以下屏幕调整侧边栏
            if (this.screenWidth <= 1024) {
                if (!this.isCollapse) {
                    this.widthVal = '180px'; // 缩小侧边栏宽度
                } else {
                    this.widthVal = '70px'; // 折叠状态也相应缩小
                }
            } else {
                // 恢复默认宽度
                if (!this.isCollapse) {
                    this.widthVal = '200px';
                } else {
                    this.widthVal = '80px';
                }
            }
        },

        collapseChange() {
            this.isCollapse = !this.isCollapse;
            this.handleResize(); // 调用响应式处理
        },

        scrollPrev() {
            const scrollContainer = document.querySelector('.nav-tabs .el-tabs__nav');
            scrollContainer.scrollBy(-100, 0);
        },
        scrollNext() {
            const scrollContainer = document.querySelector('.nav-tabs .el-tabs__nav');
            scrollContainer.scrollBy(100, 0);
        },
        getTabIcon(name) {
            const icons = {
                'home': 'el-icon-s-home',
                'center': 'el-icon-user-solid',
                'DataRegistration': 'el-icon-document-add',
                'MessageInfo': 'el-icon-message-solid',
                'CompanyInfoView': 'el-icon-office-building',
                'DataReview': 'el-icon-finished',
                'ReviewPage': 'el-icon-edit-outline'
            };
            return icons[name] || 'el-icon-document';
        },

        // 保持菜单展开状态
        keepMenuOpen(path) {
            this.$nextTick(() => {
                const menuItem = document.querySelector(`.el-menu-item[data-path="${path}"]`);
                if (menuItem) {
                    const submenu = menuItem.closest('.el-submenu');
                    if (submenu) {
                        submenu.classList.add('is-opened');
                        submenu.querySelector('.el-submenu__title').setAttribute('aria-expanded', 'true');
                    }
                }
            });
        },

        // 添加标签页
        addTab(route) {
            if (!route.name || route.meta?.hideTab) return;

            // 生成完整路径，包含query参数
            const fullPath = route.fullPath || route.path + (route.query ? '?' + new URLSearchParams(route.query).toString() : '');

            const tabExists = this.tabs.some(tab => tab.fullPath === fullPath);
            if (!tabExists) {
                this.tabs.push({
                    title: route.meta?.title || route.name,
                    name: route.name,
                    path: route.path,
                    fullPath: fullPath,
                    query: route.query,
                    // 修改：所有标签页都可以关闭
                    closable: true
                });
            }
            this.activeTab = fullPath;
        },

        // 移除标签页
        removeTab(targetName) {
            // 如果关闭的是当前激活标签，则跳转到指定页面
            if (this.tabs.length === 1) {
                this.$router.push('/home').then(() => {
                    this.tabs = [];
                }).catch(err => {
                    console.error('跳转失败:', err);
                });
                return;
            }

            const tabs = this.tabs;
            let activeTab = this.activeTab;
            let nextRoute = null;

            if (activeTab === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.fullPath === targetName) {
                        const nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeTab = nextTab.fullPath;
                            nextRoute = {
                                path: nextTab.path,
                                query: nextTab.query
                            };
                        }
                    }
                });
            }

            this.activeTab = activeTab;
            this.tabs = tabs.filter(tab => tab.fullPath !== targetName);

            // 如果关闭的是当前激活标签，跳转到下一个标签
            if (nextRoute) {
                this.$router.push(nextRoute);
            }
        },

        // 标签页点击
        tabClick(tab) {
            const route = this.tabs.find(item => item.fullPath === tab.paneName);
            if (route) {
                this.$router.push({
                    path: route.path,
                    query: route.query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error(err);
                    }
                });
            }
        },

        // 根据路由设置激活标签
        setActiveTabByRoute(route) {
            const fullPath = route.fullPath || route.path + (route.query ? '?' + new URLSearchParams(route.query).toString() : '');
            const tab = this.tabs.find(item => item.fullPath === fullPath);
            if (tab) {
                this.activeTab = tab.fullPath;
                // 确保el-tab-pane的name和activeTab匹配
                this.$nextTick(() => {
                    const pane = this.$refs.tabs?.$children.find(child =>
                        child.$vnode.key === tab.fullPath
                    );
                    if (pane) {
                        pane.currentName = tab.fullPath;
                    }
                });
            }
        },

        commandHandler(cmd) {
            if (cmd === 'userInfo') {
                this.$router.replace('/index/center');
            }
            if (cmd === 'setting') {
                //this.$router.replace('/changePassword');
            }
            if (cmd === 'logout') {
                this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.getRequest("/web/logout");
                    this.$store.commit('REMOVE_USER');
                    this.$store.commit('REMOVE_ROUTES');
                    this.$router.replace("/login");
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            }
        },
        collapseChange() {
            this.isCollapse = !this.isCollapse;
            if (this.isCollapse) {
                this.widthVal = '80px';
            } else {
                this.widthVal = '200px';
            }
        },
        goToCompanyHome() {
            try {
                const routeData = this.$router.resolve({ path: '/' });
                window.open(routeData.href, '_blank');
            } catch (error) {
                console.error('跳转失败:', error);
                this.$message.error('跳转到官网首页失败');
            }
        }
    }
};
</script>

<style>
.collapse-btn {
    float: left;
    padding: 0 10px;
    cursor: pointer;
    color: white;
    font-size: 20px;
}

.el-menu-vertical-demo1:not(.el-menu--collapse) {
    width: 200px;
    list-style-type: none;
    top: 60px;
    margin: 0;
    padding: 0;
    height: 100%;
    position: fixed;
    overflow: auto;
}

.logo {
    width: 35px;
}

.web-title {
    margin: 0 40px 0 10px;
    font-size: 26px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.homeHeader {
    display: flex;
    background-color: #274b86;
    position: fixed;
    top: 0;
    z-index: 200;
    width: 100%;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.homeHeader:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-tabs {
    margin: 0;
    background: #f5f7fa;
    width: 80%;
    box-sizing: border-box;
    position: relative;
    padding: 6px 30px;
}

.nav-tabs .el-tabs__header {
    margin: 0;
    position: relative;
}

.nav-tabs .el-tabs__nav {
    border: none;
    white-space: nowrap;
    display: inline-block;
    transition: transform 0.3s;
}

.nav-tabs .el-tabs__nav-scroll {
    overflow: hidden;
}

.nav-tabs .el-tabs__nav-prev,
.nav-tabs .el-tabs__nav-next {
    position: absolute;
    top: 8px;
    height: 28px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    background: #f5f7fa;
    z-index: 2;
    cursor: pointer;
}

.nav-tabs .el-tabs__nav-prev {
    left: 0;
    box-shadow: 5px 0 5px -3px rgba(0, 0, 0, 0.1);
}

.nav-tabs .el-tabs__nav-next {
    right: 0;
    box-shadow: -5px 0 5px -3px rgba(0, 0, 0, 0.1);
}

.nav-tabs {
    padding: 14px 32px;
    background: #f5f7fa;
    margin: 0 30px 12px 30px;
}

.nav-tabs .el-tabs__item {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #333;
    background: #fff;
    margin: 2px 6px;
    border-radius: 4px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    position: relative;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    border: 1px solid #d1d5da;
    transform: translateY(0);
}

.nav-tabs .el-tabs__item:hover {
    color: #274b86;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border: 1px solid #a0b4cc;
    transform: translateY(-1px);
}

.nav-tabs .el-tabs__item.is-active {
    color: #274b86;
    background: #e6f0ff;
    font-weight: 500;
    padding: 0 20px;
    box-shadow: 0 2px 8px rgba(70, 130, 255, 0.2);
    border-top: 2px solid #4a90e2 !important;
    border-right: 2px solid #4a90e2 !important;
    border-bottom: 2px solid #4a90e2 !important;
    border-left: 2px solid #4a90e2 !important;
    transform: translateY(-1px);
}

.nav-tabs .el-tabs__item .is-icon-close {
    margin-left: 6px;
    color: #909399;
    font-size: 12px;
}

.nav-tabs .el-tabs__nav-wrap::after {
    display: none;
}

.el-dropdown-link img {
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 5px;
    vertical-align: middle;
    margin-left: 8px;
}

.el-dropdown-link {
    display: flex;
    align-items: center;
}

.el-main {
    margin-top: 60px;
}

.sidebar>ul {
    height: 100%;
    top: 60px;
    margin: 0;
    padding: 0;
    overflow: auto;
    position: fixed;
}

body {
    background: #f0f2f5;
}

@media screen and (max-width: 1366px) {
    .sidebar-container .el-menu-vertical-demo1:not(.el-menu--collapse) {
        width: 180px !important;
    }
    
    .sidebar-container .el-menu--collapse {
        width: 70px !important;
    }
    
    /* 调整侧边栏字体大小 */
    .sidebar-container .el-submenu__title,
    .sidebar-container .el-menu-item {
        font-size: 13px !important;
    }
    
    .sidebar-container .el-submenu__title i,
    .sidebar-container .el-menu-item i {
        font-size: 16px !important;
        margin-right: 4px !important;
    }
    
    /* 调整主内容区域间距 */
    .el-main {
        padding: 10px !important;
    }
    
    /* 调整导航标签页 */
    .nav-tabs {
        margin: 0 15px 12px 15px !important;
        padding: 10px 25px !important;
    }
    
    .nav-tabs .el-tabs__item {
        height: 32px !important;
        line-height: 32px !important;
        font-size: 12px !important;
        padding: 0 15px !important;
        margin: 2px 4px !important;
    }
    
    /* 调整头部 */
    .homeHeader {
        padding: 0 15px !important;
    }
    
    .web-title {
        font-size: 22px !important;
        margin: 0 20px 0 8px !important;
    }
    
    .logo {
        width: 30px !important;
    }
    
    .el-dropdown-link img {
        width: 28px !important;
        height: 28px !important;
    }
}

/* 更小屏幕的适配 */
@media screen and (max-width: 768px) {
    .sidebar-container .el-menu-vertical-demo1:not(.el-menu--collapse) {
        width: 160px !important;
    }
    
    .sidebar-container .el-menu--collapse {
        width: 60px !important;
    }
    
    .web-title {
        font-size: 18px !important;
        margin: 0 10px 0 5px !important;
    }
    
    .nav-tabs {
        margin: 0 10px 8px 10px !important;
        padding: 8px 20px !important;
    }
    
    .nav-tabs .el-tabs__item {
        height: 28px !important;
        line-height: 28px !important;
        font-size: 11px !important;
        padding: 0 12px !important;
    }
}

/* 确保侧边栏在折叠状态下的样式 */
.el-menu-vertical-demo1.el-menu--collapse {
    width: 80px;
}

/* 原有样式保持不变 */
.el-menu-vertical-demo1:not(.el-menu--collapse) {
    width: 200px;
    list-style-type: none;
    top: 60px;
    margin: 0;
    padding: 0;
    height: 100%;
    position: fixed;
    overflow: auto;
}
</style>